enum FeatureType {
  PDF_TEMPLATES = "PDF_TEMPLATES",
  INVENTORY = "INVENTORY",
  CONTACT_MODE = "CONTACT_MODE",
  AI_FEATURE = "AI_FEATURE"
}

export default FeatureType;
